var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: ["signpost-card", _vm.type ? "signpost-card--" + _vm.type : null]
    },
    [
      _c(
        "router-link",
        {
          staticClass: "signpost-card__link",
          attrs: { to: _vm.path("orka" + _vm.uCFirst(_vm.type)) },
          nativeOn: {
            click: function($event) {
              return _vm.$root.$emit("trackToGTM", ["btnClick", _vm.type])
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "signpost-card__background" },
            [
              _c("v-image", {
                staticClass: "signpost-card__image",
                attrs: {
                  tiny: _vm.getImage(_vm.type),
                  alt: "Price Card Background"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "signpost-card__inner" },
            [
              _c("v-icon", {
                staticClass: "signpost-card__icon",
                attrs: { name: "symbols/cards/" + _vm.type }
              }),
              _vm._v(" "),
              _c("v-typo", {
                staticClass: "signpost-card__headline",
                attrs: { variant: "h3" },
                domProps: { innerHTML: _vm._s(_vm.content.headline) }
              }),
              _vm._v(" "),
              _c("v-typo", {
                staticClass: "signpost-card__perex",
                attrs: { variant: "body-paragraph" },
                domProps: { innerHTML: _vm._s(_vm.content.perex) }
              }),
              _vm._v(" "),
              _c("v-typo", {
                staticClass: "signpost-card__price",
                attrs: { variant: "h4" },
                domProps: { innerHTML: _vm._s(_vm.content.price) }
              }),
              _vm._v(" "),
              _c(
                "v-button",
                {
                  staticClass: "signpost-card__button",
                  attrs: { variant: _vm.buttonVariantClass, element: "div" }
                },
                [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.$t("button.learnMore")) +
                      "\n\t\t\t"
                  )
                ]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }